import React, { useContext, useEffect, useMemo } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import useEntity from '../../../hooks/useEntity';
import Loading from '../../../components/Loading';
import appRoutes from '../../appRoutes';
import useEntityLink from '../../../components/GlobalSearch/hooks/useEntityLink';
import Typography from '../../../kingpin/atoms/Typography';
import OrderDetails from '../../../screens/OrderDetails';
import EntityDetailsShow from '../../../screens/EntityDetailsShow';
import NAVIGATION from '../../../kingpin/navigation/constants';
import NavSideBarContext from '../../../contexts/NavSideBarContext';

const EngagementModeContentDiv = styled.div<{ isMainNavOpen: boolean }>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: ${(props) =>
    `calc(100vw - ${props.isMainNavOpen ? NAVIGATION.OPENED_NAV_WIDTH : NAVIGATION.COLLAPSED_NAV_WIDTH}px - ${NAVIGATION.OPENED_NAV_WIDTH}px)`};
`;

const EngagementRedirect = ({
  entity,
  engagementContentSettings,
}: {
  engagementContentSettings: UserManagement.EngagementContentSettings;
  entity: EntityDetails.Entity;
}) => {
  const navigate = useNavigate();

  const entityLink = useEntityLink({
    entity,
    value: engagementContentSettings.mappings[0].primaryFieldValue,
  });

  useEffect(() => {
    if (entityLink) {
      navigate(entityLink);
    }
  }, [engagementContentSettings, entity.primaryField, entityLink, navigate]);

  return (
    <div>
      <Typography.Header type="H1">
        Page not found, redirecting...
      </Typography.Header>
    </div>
  );
};

const EngagementModeSwitch = ({
  engagementContentSettings,
}: {
  engagementContentSettings: UserManagement.EngagementContentSettings;
}) => {
  const { isOpen } = useContext(NavSideBarContext);
  const firstMapping = useMemo(() => {
    return engagementContentSettings.mappings[0];
  }, [engagementContentSettings.mappings]);
  const { entity, app } = useEntity({
    entityId: firstMapping.entityId,
    entityAppId: firstMapping.entityAppId,
  });

  if (!entity || !app) {
    return <Loading />;
  }

  return (
    <EngagementModeContentDiv isMainNavOpen={isOpen}>
      <Routes>
        <Route
          path={appRoutes.loggedIn.showOrderDetails}
          element={<OrderDetails />}
        />
        <Route
          path={appRoutes.loggedIn.showEntityApp}
          element={<EntityDetailsShow isEngagementMode />}
        />
        <Route
          path={appRoutes.loggedIn.showEntityAppContentTab}
          element={<EntityDetailsShow isEngagementMode />}
        />
        <Route
          path="*"
          element={
            <EngagementRedirect
              engagementContentSettings={engagementContentSettings}
              entity={entity}
            />
          }
        />
      </Routes>
    </EngagementModeContentDiv>
  );
};

export default EngagementModeSwitch;
